module.exports = __webpack_public_path__ + "img/27.81300ade.jpeg";